// https://docs.amplify.aws/lib/client-configuration/configuring-amplify-categories/q/platform/js/
// https://zenn.dev/longbridge/articles/0285863192edcd
export const authConfig = {
  region: import.meta.env.VITE_COGNITO_REGION,
  userPoolId: import.meta.env.VITE_COGNITO_POOL_ID,
  userPoolWebClientId: import.meta.env.VITE_COGNITO_APPCLIENT_ID,
  cookieStorage: {
    domain: import.meta.env.VITE_AUTH_COOKIE_STORAGE_DOMAIN,
    path: "/",
    expires: 365,
    sameSite: "strict",
    secure: process.env.NODE_ENV !== "development"
  },
  authenticationFlowType: "USER_SRP_AUTH" // Default
};
